<style>
  .eso-s-input{
    padding-left: 0;
  }
  .eso-s-input>input[type='text'] {
    box-sizing:border-box;
    border: 1px solid #ddd;
    border-radius: 3px;
    height: 42px;
    padding-left: 38px;
    padding-right: 116px;
    font-size: 15px;
    width: 99%;
  }
  .eso-s-input>i {
    position: absolute;
    font-size: 18px;
    line-height: 42px;
    text-indent: 10px;
    color:#C2C2C2;
  }
  .eso-s-input>button {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    font-size: 15px;
    position: absolute;
    padding: 0px 28px;
    height: 42px;
    margin-left: -118px;
  }
</style>

<template>
  <div class="eso-s-input">
    <i class="iconfont icon-sousuo-sousuo"></i>
    <input type="text" placeholder="请输入关键词" :value="currentValue" @input="handleInput" />
    <el-button type="default" @click="submit">指数查询</el-button>
  </div>
</template>

<script>
export default {
  name: 'searchInput',
  props: {
    value: [String, Number]
  },
  watch: {
    'value' (val, oldValue) {
      this.setCurrentValue(val)
    }
  },
  data () {
    return {
      currentValue: this.value
    }
  },
  methods: {
    submit (event) {
      this.$emit('click', event)
    },
    setCurrentValue (value) {
      this.currentValue = value
      this.$emit('input', value)
      this.$emit('change', value)
    },
    handleInput (event) {
      this.setCurrentValue(event.target.value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// input.vue?557321df